import { Component, OnInit, Input, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { SubjectUnit } from '../../models/subject';
import { SyllabusProgress } from '../../models/syllabus-progress';

@Component({
  selector: 'app-lesson-note-unit',
  templateUrl: './lesson-unit.component.html',
  styleUrls: ['./lesson-unit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LessonNoteUnitComponent implements OnInit {

  constructor() { }

  @Input('units') units: Array<SubjectUnit>
  @Input() subject_title: string;
  @Input() unitProgress: SyllabusProgress;
  loading: boolean = true;

  ngOnInit(){

  }
  
  ngOnChanges(changes: SimpleChanges) {
    if(changes['units'] && changes['units'].currentValue.length){
      this.loading = false;
    }
  }

}
